import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Tenants API.
 */
export const TENANTS_API_ENDPOINTS = {
  listTenants: {
    generated: 'tenantsAdminControllerListTenantsV1',
    method: 'get',
    path: '/api/v1/admin/tenants',
  },
  getTenant: {
    generated: 'tenantsAdminControllerGetTenantV1',
    method: 'get',
    path: '/api/v1/admin/tenants/:idOrSlug',
  },
  createTenant: {
    generated: 'tenantsAdminControllerCreateTenantV1',
    method: 'post',
    path: '/api/v1/admin/tenants',
  },
  updateTenant: {
    generated: 'tenantsAdminControllerUpdateTenantV1',
    method: 'put',
    path: '/api/v1/admin/tenants/:id',
  },
  deleteTenant: {
    generated: 'tenantsAdminControllerRemoveTenantV1',
    method: 'delete',
    path: '/api/v1/admin/tenants/:id',
  },
  listTenantMembers: {
    generated: 'tenantMembersControllerListTenantMembersV1',
    method: 'get',
    path: '/api/v1/admin/tenants/:tenantId/members',
  },
  addTenantMember: {
    generated: 'tenantMembersControllerAddTenantMemberV1',
    method: 'post',
    path: '/api/v1/admin/tenants/:tenantId/members',
  },
  getTenantMember: {
    generated: 'tenantMembersControllerGetTenantMemberV1',
    method: 'get',
    path: '/api/v1/admin/tenants/:tenantId/members/:userId',
  },
  deleteTenantMember: {
    generated: 'tenantMembersControllerRemoveTenantMemberV1',
    method: 'delete',
    path: '/api/v1/admin/tenants/:tenantId/members/:userId',
  },
  updateTenantMembership: {
    generated: 'tenantMembersControllerUpdateTenantMembershipV1',
    method: 'put',
    path: '/api/v1/admin/tenants/:tenantId/memberships/:membershipId',
  },
  deleteTenantMembership: {
    generated: 'tenantMembersControllerRemoveTenantMembershipV1',
    method: 'delete',
    path: '/api/v1/admin/tenants/:tenantId/memberships/:membershipId',
  },
} as const satisfies Record<string, EndpointDef>;

export type TenantsEndpointName = keyof typeof TENANTS_API_ENDPOINTS;
